import React from 'react';
import { useAuth } from '../context/AuthContext';
import SalesDashboard    from './dashboard/SalesDashboard';
import DesignerDashboard from './dashboard/DesignerDashboard';
import AdminDashboard    from './dashboard/AdminDashboard';

export default function Dashboard() {
  const { user } = useAuth();
  const role = user?.role?.toLowerCase();

  if (role === 'designer') return <DesignerDashboard />;
  if (role === 'sales')    return <SalesDashboard />;

  // admin, manager, and any unrecognised roles get the full admin view
  return <AdminDashboard />;
}
